import { useEffect } from "react";

import type { ConversionRatesCategoryLeadersListParams } from "@similarweb/pro-api-client";
import Sentry from "@similarweb/sentry-logger";

import { useApiQuery } from "app/modules/api-client";

export const useConversionRateLeadersData = (
    params: ConversionRatesCategoryLeadersListParams,
    { enabled }: { enabled: boolean },
) => {
    const query = useApiQuery(
        {
            tag: "WebConversionRates",
            methodName: "conversionRatesCategoryLeadersList",
            options: { enabled, placeholderData: undefined },
        },
        params,
    );

    const { isError, error } = query;

    useEffect(() => {
        if (isError) {
            Sentry.errorTracker({
                e: error instanceof Error ? error : new Error("Conversion rate leaders request failed"),
                message: "Failed to load conversion rate leaders",
                level: "error",
            });
        }
    }, [isError, error]);

    return query;
};
